import { Box, Button, FormField, MaskedInput, Text } from 'grommet';
import { FastForward, Next, Previous, Rewind } from 'grommet-icons';
import React, { useState } from 'react';

export interface PaginationProps {
  Page: number;
  Last: number;
  onChange: (page: string) => void;
}

const Pagination: React.FC<PaginationProps> = ({ Page, Last, onChange }): JSX.Element => {
  const [temporaryPage, setTemporaryPage] = useState(Page);

  const onClickRewind = (): void => {
    onChange('1');
    setTemporaryPage(1);
  };

  const onClickPrevious = (): void => {
    if (temporaryPage > 1) {
      onChange((temporaryPage - 1).toString());
      setTemporaryPage(temporaryPage - 1);
    } else if (temporaryPage <= 1) {
      setTemporaryPage(1);
    }
  };

  const onChangeMask = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    if (evt.target.value === '' || evt.target.value === undefined) {
      setTemporaryPage(0);
    } else {
      setTemporaryPage(
        parseFloat(evt.target.value),
      );
    }
  };

  const onKeyUpMask = (evt: React.KeyboardEvent<HTMLInputElement>): void => {
    if (evt.key === 'Enter' && temporaryPage >= Last) {
      onChange(Last.toString());
      setTemporaryPage(Last);
    } else if (evt.key === 'Enter' && temporaryPage < Last) {
      onChange(temporaryPage.toString());
      setTemporaryPage(temporaryPage);
    }
  };

  const onClickNext = (): void => {
    if (temporaryPage < Last) {
      onChange((temporaryPage + 1).toString());
      setTemporaryPage(temporaryPage + 1);
    } else if (temporaryPage >= Last) {
      setTemporaryPage(Last);
    }
  };

  const onClickLast = (): void => {
    onChange(Last.toString());
    setTemporaryPage(Last);
  };

  return (
    <Box
      fill="horizontal"
      background="background-contrast"
      justify="center"
      align="center"
      pad="small"
      direction="row"
      gap="small"
      height={{
        min: '50px',
      }}
    >
      <Button
        plain
        title="First Page"
        icon={<Rewind />}
        disabled={!(temporaryPage !== 1)}
        onClick={onClickRewind}
      />
      <Button
        plain
        title="Previous Page"
        icon={<Previous />}
        disabled={!(temporaryPage !== 1)}
        onClick={onClickPrevious}
      />
      <Text>
        Page
      </Text>
      <FormField
        width="small"
        margin={{
          left: '10px',
          right: '10px',
          top: '10px',
          bottom: '10px',
        }}
      >
        <MaskedInput
          value={temporaryPage}
          onChange={onChangeMask}
          onKeyUp={onKeyUpMask}
          mask={[
            {
              regexp: /d*/,
              placeholder: '1',
            },
          ]}
        />
      </FormField>
      <Text>
        Of
      </Text>
      <Text>
        {Last.toString()}
      </Text>
      <Button
        plain
        title="Next Page"
        icon={<Next />}
        disabled={(temporaryPage === Last)}
        onClick={onClickNext}
      />
      <Button
        plain
        title="Last Page"
        icon={<FastForward />}
        disabled={(temporaryPage === Last)}
        onClick={onClickLast}
      />
    </Box>
  );
};

Pagination.displayName = 'Pagination';

export default Pagination;
